import { lazy, Suspense } from 'react';
import { useLang } from '@/lib/LanguageContext';
import { useCarnet } from '@/lib/CarnetContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';
import { ModalShell } from '@/components/shared/ModalShell';
import { ModalSkeleton } from '@/components/ui/ModalSkeleton';

/**
 * CarnetModal — Océanne (wrapper modal pur).
 * Contenu délégué à CarnetContent (single source).
 * Page SEO indexable : routes/carnet.tsx (CarnetContent variant="page").
 *
 * Phase 27.84 — lazy-load CarnetContent. ModalShell unmount son enfant quand
 * isOpen=false ; React n'évalue donc `<CarnetContent>` (et son lazy import)
 * qu'à la première ouverture. Chunk dédié dans vite.config.ts (manualChunks
 * /carnet-content/).
 */
const CarnetContent = lazy(() =>
  import('./carnet-content').then((m) => ({ default: m.CarnetContent }))
);

export function CarnetModal() {
  const { lang } = useLang();
  const { isOpen, close } = useCarnet();
  const text = ta(t.carnet, lang);

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={close}
      eyebrow={text.eyebrow}
      title={text.title}
      closeLabel={text.modal_close_label}
      ariaLabelledById="carnet-modal-title"
      printable
      printLabel={text.modal_print_label}
      maxWidth="max-w-4xl"
    >
      <Suspense fallback={<ModalSkeleton />}>
        <CarnetContent variant="modal" onClose={close} />
      </Suspense>
    </ModalShell>
  );
}
